<template>
  <SoWidget title="Refund" class="mt-8">
    <div class="d-flex">
      <SoTextField
        v-model="refund.refundAmount"
        :rules="[rules.required, rules.currency, refundAmountValidation]"
        class="refund-text-field mr-8"
        label="Amount"
        type="number"
        prefix="£"
        @update:model-value="$emit('update:modelValue', refund)"
      />
      <SoTextField
        v-model="refund.refundReason"
        class="flex-1-1"
        label="AWS Case ID"
        :maxlength="REFUND_REFERENCE_MAX_LENGTH"
        @update:model-value="$emit('update:modelValue', refund)"
      />
    </div>
    <p class="mt-6">
      Balance after refund:
      <span class="font-weight-medium">{{ balanceAfterRefund }}</span>
    </p>
    <SoAlert
      class="mt-6"
      type="info"
      message="This refund will be processed immediately and cannot be reversed."
    >
      Refund will take up to 4-7 working days before showing on the account.
    </SoAlert>
  </SoWidget>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { formatBalance } from "@/helpers/moneyHelpers"
  import rules from "@/validators/rules"
  import refundAmountValidation from "@/validators/refundAmount"
  import { REFUND_REFERENCE_MAX_LENGTH } from "@/constants/finance"
  import SoWidget from "@/components/SoWidget.vue"
  import SoTextField from "@/components/formControls/SoTextField.vue"
  import SoAlert from "@/components/SoAlert.vue"

  export default defineComponent({
    components: {
      SoWidget,
      SoTextField,
      SoAlert,
    },
    props: {
      modelValue: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        rules,
        REFUND_REFERENCE_MAX_LENGTH,
        refundAmountValidation,
        current: useCurrentAccountStore(),
        refund: {
          refundAmount: "",
          refundReason: "",
        },
      }
    },
    computed: {
      balanceAfterRefund() {
        let balanceAfterRefund = this.current.account.data.balance
        const refundAmountNumber = Number(this.refund.refundAmount)
        if (!isNaN(refundAmountNumber) && refundAmountNumber > 0) {
          balanceAfterRefund += refundAmountNumber
        }
        return formatBalance(balanceAfterRefund)
      },
    },
  })
</script>

<style lang="css" scoped>
  .refund-text-field {
    min-width: 270px;
  }
</style>
